// Dev console → APIs de DEV (dev-*), sin cruces a staging/qa.
export const environment = {
  production: false,
  inactive: false,

  BASE_LA: 'https://dev-kredit-api.creditotal.online',
  BASE_RECHARGE: 'https://dev-recharge-api.creditotal.online',
  BASE_FORNT2: 'https://dev-console.creditotal.online',
  // El portal de los comercios. De aca sale la direccion propia de cada uno
  // (<base>/c/<CODIGO>), la que se le entrega para que su gente entre.
  BASE_PORTAL_COMERCIOS: 'https://mt-comercio.creditotal.online',
  BASE_FORNT: 'https://dev-app.creditotal.online',
  redirectRoute: '/console/create-constacts',
  searchClient: '/console/create-constacts',
  psicometrico: '/console/psicometrico',
  initRoute: '/console/search-client',
  BASE_BDV_API: 'https://dev-api-bdv-payment-button.creditotal.online',

  externalPsicometrico: 'https://www.acredita.com.ve:8860/psicometrico/home_test.php',

  loginRoute: '/login',
  logoutRoute: '/logout',

  socketBase: {
    SOCKET_ENDPOINT: 'https://dev-api-socket.creditotal.online/',
  },

  ClieID: '12',
  CED: '11314836',
  IP_LOCAL: '159.223.176.142',
  REWARDS_FRONT_URL: 'https://dev-app-rewards.creditotal.online',

  ONBOARDING_LA: 'https://dev-api-onboarding.creditotal.online',

  ANALYSIS_REPORT: 'https://analytics-api.creditotal.online',

  BASE_CASH_REGISTER_PAYMENT: 'https://dev-api-payment-pos.creditotal.online',

  TRUSTX: 'https://trustx-dev-api.akeela.co',
};
